var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarAlertGlucose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3D7B0B7-E0B5-4B04-BD3E-C3C256AC5D44") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail",
    transform: "translate(-215.000000, -733.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(216.000000, 734.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar-Phantom"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.2,
    stroke: "#FF335C",
    cx: 16,
    cy: 16,
    r: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.999683,8 L21.2885882,15.4703281 C21.7793288,16.3103296 22.02516,17.2728765 21.9979649,18.2473527 C21.9660069,19.1854216 21.7043503,20.1008715 21.2363491,20.9122119 C20.1510042,22.8168558 18.1445605,24 15.9998367,24 C13.8592613,24 11.8549686,22.8193346 10.7691628,20.9190286 C10.298396,20.1045896 10.0348957,19.1854216 10.0021693,18.2434796 C9.97405243,17.2632712 10.21973,16.2948371 10.7113924,15.4487935 L10.7113924,15.4487935 L15.999683,8 Z M19.3361999,17.0984231 C18.8840657,17.0984231 18.5175241,17.4765856 18.5175241,17.9430346 C18.5158451,19.4055254 17.3666757,20.5910873 15.9486122,20.5926865 C15.4970271,20.5926862 15.1304855,20.9708487 15.1304855,21.4372977 C15.1304855,21.9037468 15.4970271,22.2819093 15.9491614,22.2819093 C18.2710052,22.2793765 20.1522454,20.3385487 20.1548755,17.9436219 C20.1548755,17.4765856 19.7883342,17.0984231 19.3361999,17.0984231 Z",
    id: "Combined-Shape",
    fill: "#FF335C",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAlertGlucose);
export default __webpack_public_path__ + "static/media/avatar-alert-glucose.c308ef49daa29ee3aae58fd3bbb9f811.svg";
export { ForwardRef as ReactComponent };